module.exports = __webpack_public_path__ + "static/media/Gallery-13.e77d6440.jpg";